// extracted by mini-css-extract-plugin
module.exports = {"titleLineHeight":"26","bpSizeSmall":"420","bpSizeSmallMedium":"600","bpSizeMedium":"768","bpSizeLarge":"1024","bpSizeWide":"1280","contentLimit":"960","headerHeight":"50"};